import React, { useState, useEffect } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";
import Swal from "sweetalert2";
import Loader from "../../../Utils/Loader";
import { fDateTimeSuffix } from "../../../Utils/Date_formet";

import {
  getOpenOrder,
  EditOpenOrderPrice,
  GET_ALL_ORDERS
} from "../../../Service/user.service";
import { deleteOrder } from "../../../Service/admin.service";

import "react-datepicker/dist/react-datepicker.css";
import DeltaSocketClient from "../../../Utils/main/DeltaSocket";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import { usePrices } from "../../../context/PriceContext";



const Signals = () => {
  const location = useLocation();
  const [SignalsData, setSignalsData] = useState({ loading: true, data: [] });
  const [OpenOrdersData, setOpenOrdersData] = useState({
    loading: true,
    data: [],
  });
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [activeTab, setActiveTab] = useState(location?.state?.openBook ? "openOrders" : "orders");

  const [editingPriceId, setEditingPriceId] = useState(null);
  const [editPriceValue, setEditPriceValue] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);
  const [livePrices, setLivePrices] = useState({});

  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const token = localStorage.getItem("token");
  const prices = usePrices(); // ✅ FIXED


  const tabs = [
    { value: "orders", label: "Orders", icon: "bi bi-bag-check" },
    { value: "openOrders", label: "Pending Orders", icon: "bi bi-cart-check" },
  ];

  const roundSmart = (value) => {
    if (isNaN(value)) return null;
    value = Number(value);

    let digits;
    if (Math.abs(value) >= 1000) {
      digits = 2;
    } else if (Math.abs(value) >= 1) {
      digits = 2;
    } else if (Math.abs(value) >= 0.01) {
      digits = 4;
    } else {
      digits = 6;
    }

    return Number(value.toFixed(digits));
  };

  const getClientsignals = async () => {
    setSignalsData({ loading: true, data: [] });

    try {
      const response = await GET_ALL_ORDERS({
        _id: isgotodashboard ? gotodashboard.user_id : user_details.user_id,
        token: isgotodashboard ? gotodashboard?.token : user_details.token,
      });


      if (response.status) {
        let filteredData = response.data;

        setSignalsData({
          loading: false,
          data: filteredData,
        });
      } else {

        setSignalsData({
          loading: false,
          data: [],
        });
      }
    } catch (error) {
      console.error("Orders API Error:", error);
      setSignalsData({
        loading: false,
        data: [],
      });
    }
  };

  const getClientOpenOrders = async () => {
    setOpenOrdersData({ loading: true, data: [] });

    const requestData = {
      _id: isgotodashboard ? gotodashboard.user_id : user_details.user_id,

    };

    try {
      const response = await getOpenOrder(requestData, user_details.token);

      if (response.status) {
        setOpenOrdersData({
          loading: false,
          data: response.data,
        });
      } else {

        setOpenOrdersData({
          loading: false,
          data: [],
        });
      }
    } catch (error) {
      console.error("Open Orders API Error:", error);
      setOpenOrdersData({
        loading: false,
        data: [],
      });
    }
  };

  const handlePriceEdit = (orderId, currentPrice) => {
    setEditingPriceId(orderId);
    setEditPriceValue(currentPrice ? currentPrice.toString() : "");
  };

  const handleCancelEdit = () => {
    setEditingPriceId(null);
    setEditPriceValue("");
  };

  const handleSavePrice = async (orderId) => {
    if (
      !editPriceValue ||
      isNaN(editPriceValue) ||
      parseFloat(editPriceValue) <= 0
    ) {
      alert("Please enter a valid price greater than 0");
      return;
    }

    if (!orderId || orderId.length !== 24) {
      alert("Invalid Order ID format");
      return;
    }

    setUpdateLoading(true);

    try {
      const requestData = {
        _id: orderId,
        price: parseFloat(editPriceValue),
      };
      const response = await EditOpenOrderPrice(requestData, token);

      if (response && response.status) {
        // Update the local state
        setOpenOrdersData((prevState) => ({
          ...prevState,
          data: prevState.data.map((order) =>
            order._id === orderId
              ? { ...order, price: parseFloat(editPriceValue) }
              : order
          ),
        }));

        setEditingPriceId(null);
        setEditPriceValue("");
        toast.success("Price updated successfully!");

        // Optionally refresh the data
        // getClientOpenOrders();
      } else {
        const errorMsg = response?.message || "Failed to update price";
        console.error("API Error:", errorMsg);
        alert(`Error: ${errorMsg}`);
      }
    } catch (error) {
      console.error("Error updating price:", error);
      alert(`Network Error: ${error.message || "Please try again"}`);
    } finally {
      setUpdateLoading(false);
    }
  };



  const columns = [
    {
      name: "Signals Time",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
      ),
      sortable: true,
      width: "180px",

    },
    {
      name: "Type",
      selector: (row) => row.side,
      cell: (row) => (
        <span
          className={`badge ${row.side === "BUY" ? "bg-success" : "bg-danger"}`}
          style={{ fontSize: "0.9rem" }}
        >
          {row.side}
        </span>
      ),
      sortable: true,
      width: "120px",

    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row.price,
      sortable: true,
      cell: (row) => {
        if (activeTab === "openOrders") {
          return editingPriceId === row._id ? (
            <div className="d-flex align-items-center gap-1">
              <input
                type="text"
                value={editPriceValue}
                onChange={(e) => setEditPriceValue(e.target.value)}
                className="form-control form-control-sm"
                style={{ width: "100px" }}
                disabled={updateLoading}
              />
              <button
                className="btn btn-success btn-sm p-1"
                onClick={() => handleSavePrice(row._id)}
                disabled={updateLoading}
                title="Save"
              >
                {updateLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  ></span>
                ) : (
                  <i className="bi bi-check"></i>
                )}
              </button>
              <button
                className="btn btn-secondary btn-sm p-1"
                onClick={handleCancelEdit}
                disabled={updateLoading}
                title="Cancel"
              >
                <i className="bi bi-x"></i>
              </button>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <span>
                {row.price || (
                  <span
                    role="img"
                    aria-label="loading"
                    className="animate-spin"
                  >
                    ⏳
                  </span>
                )}
              </span>

              {/* Only show Edit button if row is NOT being edited */}
              {editingPriceId !== row._id && (
                <button
                  className="btn btn-outline-primary btn-sm p-1"
                  onClick={() => handlePriceEdit(row._id, row.price)}
                  title="Edit Price"
                  style={{ fontSize: "12px" }}
                >
                  <i className="bi bi-pencil"></i>
                </button>
              )}
            </div>
          );
        }

        // Regular display for other tabs
        return (
          row.price || (
            <span role="img" aria-label="loading" className="animate-spin">
              ⏳
            </span>
          )
        );
      },
      width: "180px",
    },
    {
      name: "Live Price",
      selector: (row) => {
        const livePrice = livePrices?.[row.symbol];
        return livePrice !== null && livePrice !== undefined ? livePrice : "⏳";
      },
      cell: (row) => {
        const livePrice = livePrices?.[row.symbol];
        return livePrice !== null && livePrice !== undefined ? (
          <>{roundSmart(livePrice)}</>
        ) : (
          <div
            className="spinner-border spinner-border-sm text-success"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        );
      },

      sortable: true,
      width: "160px",

    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "160px",

    },
    {
      name: "User Type",
      selector: (row) => row.usertype == "USER" ? "MANUAL" : row.usertype,
      sortable: true,
      width: "150px",

    },
    {
      name: "Market Type",
      selector: (row) => row.market_type,
      sortable: true,
      width: "150px",

    },

    {
      name: "Platform",
      selector: (row) => row.platform,
      cell: (row) => row?.platform || "-",
      sortable: true,
      width: "130px",
    },
    ...(activeTab === "openOrders"
      ? [

        {
          name: "Actions",
          selector: (row) => row._id,
          cell: (row) => (
            <div>
              {row.usertype == "USER" && (
                <i
                  className="fa fa-trash text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDeleteOrder(row._id)}
                ></i>
              )}
            </div>
          ),
          sortable: true,
        },
      ]
      : []),
  ];

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Cancel any ongoing price edits when switching tabs
    setEditingPriceId(null);
    setEditPriceValue("");

    if (tab === "openOrders") {
      getClientOpenOrders();
    } else {
      getClientsignals();
    }
  };

  const getCurrentData = () => {
    return activeTab === "openOrders" ? OpenOrdersData : SignalsData;
  };

  // useEffect(() => {
  //   const symbols = getCurrentData()?.data?.map((order) => order.symbol) || [];
  //   if (symbols.length === 0) return;
  //   const client = DeltaSocketClient.instance;
  //   if (!client) return;

  //   // ensure subscription
  //   symbols.forEach((s) => client.subscribe(s));

  //   // 🔹 step 1: initial cache values दिखाओ
  //   symbols.forEach((s) => {
  //     const cached = client.getPrice(s);
  //     if (cached) {
  //       setLivePrices((prev) => ({ ...prev, [s]: cached }));
  //     }
  //   });

  //   // 🔹 step 2: real-time updates सुनो
  //   const handleUpdate = (data) => {
  //     if (data.symbol && data.spot_price && symbols.includes(data.symbol)) {
  //       setLivePrices((prev) => ({
  //         ...prev,
  //         [data.symbol]: data.spot_price,
  //       }));
  //     }
  //   };

  //   const oldCallback = client.onMessageCallback;
  //   client.onMessageCallback = handleUpdate;

  //   return () => {
  //     client.onMessageCallback = oldCallback;
  //   };
  // }, [getCurrentData()?.data]);



  // ✅ NEW - Much simpler!
 
 
 
  useEffect(() => {
    const symbols = getCurrentData()?.data?.map((order) => order.symbol) || [];
    if (symbols.length === 0) return;

    symbols.forEach((symbol) => {
      const priceData = prices[symbol];
      if (priceData?.spot_price) {
        setLivePrices((prev) => ({
          ...prev,
          [symbol]: priceData.spot_price,
        }));
      }
    });
  }, [getCurrentData()?.data, prices]); 


  
  useEffect(() => {
    if (activeTab === "orders") {
      getClientsignals();
    } else if (activeTab === "openOrders") {
      getClientOpenOrders();
    }
  }, [fromDate, toDate, refresh]);

  const handleChange = (date) => {
    const formatted = format(date, "yyyy-MM-dd");
    return formatted;
  };

  const handleDeleteOrder = async (orderId) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteOrder({ orderId });
          if (response?.status) {
            Swal.fire("Deleted!", "Your order has been deleted.", "success");
            setRefresh((prev) => !prev);
          } else {
            console.error("Failed to delete order:", response?.message);
          }
        } else {
          Swal.fire("Cancelled", "Your order is safe :)", "error");
        }
      });
    } catch (err) {
      console.error("Error deleting order:", err);
    }
  };

  return (
    <Content Page_title="Orders" button_status={false}>



      <div className="container mt-4 mb-2 d-flex justify-content-center">
        <ul
          className={`nav nav-tabs shadow-sm rounded w-100 ${tabs.length === 2 ? "two-tabs" : ""
            }`}

        >
          {tabs.map((tab) => (
            <li className="nav-item text-center" key={tab.value}>
              <button
                className={`nav-link ${activeTab === tab.value ? "active fw-bold text-primary" : ""
                  }`}
                onClick={() => handleTabChange(tab.value)}
              >
                <i className={tab.icon}></i> {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>


      {getCurrentData()?.loading ? (
        <Loader />
      ) : (
        <Table columns={columns} data={getCurrentData()?.data} />
      )}
    </Content>
  );
};

export default Signals;
